module.exports = __webpack_public_path__ + "img/header-rebate.b961ab98.svg";